<template>
    <footer>
      <p>José Pedro Ferreira; José Carlos Ramalho; Pedro Rangel Henriques<br>Departamento de Informática, Universidade do Minho, Braga, Portugal, 2023</p>
    </footer>
</template>
  
<style scoped>
  p {
    color: #3c3c3c;
    font-size: 12px;
    font-family: "Euclid";
  }
  footer {
    width: 100%;
    position: fixed;
    bottom: 0;
    margin-top: 30px;
    text-align: center;
    text-align: center;
  }
  </style>